<dialog #dialogElement (close)="modalClosed()">
  @if (modalContent$ | async; as modal) {
    <ng-container *ngComponentOutlet="modal.component; inputs: modal.inputs" />
  }
</dialog>
